import React, { Component } from 'react';
import './prepare-and-case-study.scss';
import SharedProfile from '../../../../shared-storage/profile';
import { getImageSource, getThemeImageSource } from '../../../utility/image-source';
import { ImageConstants } from '../../../constants/constants';
import Loading from '../../common/loading/loading';
import ExamPrepKitV2Api from '../../../apis/exam-prep-kit-v2';
import PdfViewer from '../../common/pdf-viewer/pdf-viewer';
import StandardClassworkExperience from './class-work/standard-classwork-experience';
import PracticeApi from '../../../apis/practice';
import CwContentViewer from '../../common/cw-content-viewer/cw-content-viewer';
import CaseStudyStartScreen from "../../class-specific-flow/case-study-question-set-list/case-study-start-screen/case-study-start-screen";
import AssessmentEngine from "../../common/assessment-engine/assessment-engine";
import CaseStudyEndScreen from "../../class-specific-flow/case-study-question-set-list/case-study-end-screen/case-study-end-screen";
import MyAssessmentResult from "../../my-assessment-result/my-assessment-result";
import ChapterAssessmentPerformanceReport from "../../chapter-assessment-performance-report/chapter-assessment-performance-report";

// const DEFAULT_CASE_STUDY_PDF = 'https://countingwell-public-content-prod.s3.ap-south-1.amazonaws.com/9b9957ae-ba01-4368-bca6-f725a34570c6_Tractor%20Case%20Study.pdf';

export default class PrepareAndCaseStudy extends Component {
    constructor(props) {
        super(props);
        this.meta = this.props.metaInfo || {};
        this.userInfo = SharedProfile.getProfile() || {};

        const pdfUrl = this.meta.caseStudyUrl
            || this.meta.Url
            || this.meta.conceptCardPdf;
        // || DEFAULT_CASE_STUDY_PDF;

        const chapterTitle = this.meta.chapterTitle || this.meta.title || 'Chapter';
        const isAlreadyCompleted = Boolean(this.meta.isCompleted);

        this.state = {
            loading: false,
            // When opened from Table of Contents Start button, immediately show PDF Viewer (unless already completed)
            showPdfViewer: !isAlreadyCompleted,
            pdfUrl: pdfUrl,
            pdfTitle: `${chapterTitle} - Prepare & Practice Case Study`,
            pdfStartTime: Date.now(),
            pdfAttemptNumber: isAlreadyCompleted ? 2 : 1,
            isCompleted: isAlreadyCompleted,
            categoryThemeId: this.meta.categoryThemeId || this.meta.categoryId || '',
            caseStudyQuestionsList: []
        };
    }

    componentDidMount() {
        this.fetchActivityStatus();
        
    }

    fetchActivityStatus = () => {
        const chapterKey = this.meta.chapterKey || this.meta.key;
        if (!chapterKey) return;
        ExamPrepKitV2Api.getPdfKitActivity({ chapterKey })
            .then(res => {
                const data = (res && res.data !== undefined) ? res.data : res;
                if (data && data.prepareAndCaseStudy && data.prepareAndCaseStudy.isCompleted) {
                    if (data.prepareAndCaseStudy.caseStudyQuestionsList && data.prepareAndCaseStudy.caseStudyQuestionsList.length > 0) {
                        this.setState({
                            isCompleted: true, showPdfViewer: false,
                            showCaseStudyQuestionsList: true, caseStudyQuestionsList: data.prepareAndCaseStudy.caseStudyQuestionsList,
                            pdfAttemptNumber: 2
                        }, () => {
                            if(!data.prepareAndCaseStudy.caseStudyQuestionsList.length) {
                                this.getUserPracticeActivity();
                            }
                        });
                    } else {
                        this.setState({ isCompleted: true, showPdfViewer: false, caseStudyQuestionsList: [], pdfAttemptNumber: 2 });
                    }
                }
            })
            .catch(err => {
                console.error('[PrepareAndCaseStudy] fetchActivityStatus error:', err);
            });
    }


    getUserPracticeActivity() {

        let payload = {
            type: 'CASE STUDY',
            chapterKey: this.meta.chapterKey || this.meta.key,
        }

        PracticeApi.getUserPracticeActivities(payload).then(res => {
            console.log(res)
            if (res.practiceActivity.length) {

                let allCaseStudyCompletedCount = 0, allCaseStudyCompleted = false

                res.practiceActivity.forEach(item => {
                    if (item.status === 'COMPLETED') {
                        allCaseStudyCompletedCount += 1
                    }
                })

                if (res.practiceActivity.length === allCaseStudyCompletedCount) {
                    allCaseStudyCompleted = true
                }

                this.setState({
                    userPracticeActivity: res.practiceActivity, isLoading: false,
                    isAllCaseStudyCompleted: allCaseStudyCompleted
                })
            } else {
                this.setState({ userPracticeActivity: [], isLoading: false })
            }
        }).catch(err => {
            console.log('get user Practice Activity Error', err)
        })


    }

    // ─── PdfViewer Delegate Handlers ───

    hidePdfViewer = () => {
        // Closes PDF viewer and shows the Prepare and Case Study overview screen
        this.setState({ showPdfViewer: false });
    }

    startPdfActivity = () => {
        // Called by PdfViewer on initial load
    }

    enableNextButton = () => {
        // Called when the countdown timer finishes
    }

    finishPdfConcept = (details = {}) => {
        const chapterKey = this.meta.chapterKey || this.meta.key;

        const onFinish = () => {
            if (this.props.delegate && this.props.delegate.fetchPdfKitActivity) {
                this.props.delegate.fetchPdfKitActivity();
            }
            this.setState({
                showPdfViewer: false,
                isCompleted: true,
                pdfAttemptNumber: 2
            }, () => {
                this.fetchActivityStatus();
                
            });
        };

        // Update pdf_kit_activity in backend to mark prepareAndCaseStudy completed
        if (chapterKey) {
            ExamPrepKitV2Api.updatePdfKitActivity({
                chapterKey,
                section: 'prepareAndCaseStudy',
                isCompleted: true
            }).then(() => {
                onFinish();
            }).catch(err => {
                console.error('[PrepareAndCaseStudy] Error updating pdf kit activity:', err);
                onFinish();
            });
        } else {
            onFinish();
        }
    }

    // ─── Navigation Handlers ───

    openPdfViewer = () => {
        this.setState({
            showPdfViewer: true,
            pdfStartTime: Date.now()
        });
    }

    goBackToTableOfContents = () => {
        if (this.props.back) {
            this.props.back();
        } else if (this.props.delegate && this.props.delegate.hidePrepareAndCaseStudy) {
            this.props.delegate.hidePrepareAndCaseStudy();
        }
    }

    goToHomeScreen = () => {
        if (this.props.delegate && this.props.delegate.goToHomeScreen) {
            this.props.delegate.goToHomeScreen();
        }
    }

    goToChapter = () => {
        if (this.props.delegate && this.props.delegate.goToPrepare) {
            this.props.delegate.goToPrepare();
        }
    }

    goToExamPrepKit = () => {
        if (this.props.delegate && this.props.delegate.goToExamPrepKit) {
            this.props.delegate.goToExamPrepKit();
        }
    }

    showStandardClassworkExperience(question, index) {
        this.setState({
            showStandardClassworkExperience: true,
            params: {
                selectedQuestionIndex: index,
                chapterTitle: this.meta.chapterTitle || this.meta.title || 'Chapter',
                title: question.caseStudyTitle,
                questionsList: this.state.caseStudyQuestionsList,
                chapterKey: this.meta.chapterKey || this.meta.key,
                categoryThemeId: this.meta.categoryThemeId || this.state.categoryThemeId || 1,
            }
        });
    }

    hideStandardClassworkExperience = () => {
        this.setState({
            showStandardClassworkExperience: false,
            params: null
        }, () => {
            this.fetchActivityStatus();
        });
    }

    onClickCard(item) {

        let chapterKey = item.chapters.map(data => data.key)

        let chapters = []

        for (let i = 0; i < item.chapters.length; i++) {
            chapters.push(item.chapters[i].title)
        }

        if (item.status == 'START') {
            // this.layoutShared.toggleSidebar(true, this.props.history.location.pathname)
            this.setState({
                showCaseStudyStartScreen: true,
                startAssessmentMetaInfo: {
                    chapterKey: chapterKey.join(),
                    chapterTitle: item.chapters && item.chapters.length ? item.chapters[0].title : "",
                    categoryThemeId: item.categoryId,
                    selectedChapters: item.chapters && item.chapters.length > 1 ? item.chapters : null,
                    practiceChapters: chapters.join(),
                    duration: item.duration,
                    isFromPracticeCaseStudy: true,
                    practiceActivityId: item._id,
                    viewAnswerTime: item.endTime,
                    practice: item,
                    from: "CASE STUDY"
                }
            })
        }

        if (item.status == 'IN_PROGRESS') {
            this.showAssessmentEngine(
                {
                    chapterTitle: item.chapters && item.chapters.length ? item.chapters[0].title : "",
                    isResume: true,
                    assessmentActivityId: item.assessmentActivityId,
                    categoryThemeId: item.categoryId,
                    selectedChapters: item.chapters,
                    isFromPracticeCaseStudy: true,
                    practiceChapters: chapters.join(),
                    practiceActivityId: item._id,
                    viewAnswerTime: item.endTime,
                    practice: item,
                    chapterKey: chapterKey.join(),
                    from: "CASE STUDY"
                }
            )
        }
    }

    hideCaseStudyStartScreen() {
        this.setState({ showCaseStudyStartScreen: false, selectedCaseStudy: '' })
    }

    showAssessmentEngine(data) {
        //console.log(data)
        this.setState({ showAssessmentEngine: true, showCaseStudyStartScreen: false, assessmentEngineMetaInfo: data })
    }

    showPracticeCaseStudyEndScreen(assessmentCompletedInfo) {
        console.log(assessmentCompletedInfo)
        this.setState({
            showAssessmentEngine: false,
            showAssessmentEndScreen: true,
            assessmentCompletedMetaInfo: {
                ...assessmentCompletedInfo,
                isEpkV2: true,
                calledFrom: 'EXAM_PREP_KIT_V2'
            }
        })
    }

    hidePracticeCaseStudyEndScreen = () => {
        this.setState({ showAssessmentEndScreen: false }, () => {
            this.fetchActivityStatus();
            this.getUserPracticeActivity();
        });
    };

    hasNextCaseStudy = () => {
        if (this.state.caseStudyQuestionsList && this.state.caseStudyQuestionsList.length > 0) {
            const currentIndex = this.state.params?.selectedQuestionIndex ?? -1;
            return currentIndex + 1 < this.state.caseStudyQuestionsList.length;
        }

        if (this.state.userPracticeActivity && this.state.userPracticeActivity.length > 0) {
            const currentActivityId = this.state.assessmentCompletedMetaInfo?.assessmentActivityId;
            let currentIndex = this.state.userPracticeActivity.findIndex(
                item => (item.assessmentActivityId && item.assessmentActivityId === currentActivityId) ||
                    (item._id && item._id === currentActivityId)
            );
            if (currentIndex === -1 && this.state.startAssessmentMetaInfo?.practiceActivityId) {
                currentIndex = this.state.userPracticeActivity.findIndex(
                    item => item._id === this.state.startAssessmentMetaInfo.practiceActivityId
                );
            }
            return currentIndex !== -1 && currentIndex + 1 < this.state.userPracticeActivity.length;
        }

        return false;
    };

    showNextCaseStudy = () => {
        if (this.state.caseStudyQuestionsList && this.state.caseStudyQuestionsList.length > 0) {
            const currentIndex = this.state.params?.selectedQuestionIndex ?? -1;
            if (currentIndex + 1 < this.state.caseStudyQuestionsList.length) {
                const nextQuestion = this.state.caseStudyQuestionsList[currentIndex + 1];
                this.setState({ showAssessmentEndScreen: false }, () => {
                    this.showStandardClassworkExperience(nextQuestion, currentIndex + 1);
                });
                return;
            }
        }

        if (this.state.userPracticeActivity && this.state.userPracticeActivity.length > 0) {
            const currentActivityId = this.state.assessmentCompletedMetaInfo?.assessmentActivityId;
            let currentIndex = this.state.userPracticeActivity.findIndex(
                item => (item.assessmentActivityId && item.assessmentActivityId === currentActivityId) ||
                    (item._id && item._id === currentActivityId)
            );
            if (currentIndex === -1 && this.state.startAssessmentMetaInfo?.practiceActivityId) {
                currentIndex = this.state.userPracticeActivity.findIndex(
                    item => item._id === this.state.startAssessmentMetaInfo.practiceActivityId
                );
            }
            if (currentIndex !== -1 && currentIndex + 1 < this.state.userPracticeActivity.length) {
                const nextActivity = this.state.userPracticeActivity[currentIndex + 1];
                this.setState({ showAssessmentEndScreen: false }, () => {
                    this.onClickCard(nextActivity);
                });
                return;
            }
        }

        this.hidePracticeCaseStudyEndScreen();
    };

    showViewAnswerScreen(assessmentEndScreenInfo) {
        this.setState({
            showAssessmentEndScreen: false, showAssessmentViewAnswersScreen: true,
            assessmentEndScreenInfo: assessmentEndScreenInfo.meta
        })
    }

    hideViewAnswerScreen() {
        this.setState({
            showAssessmentViewAnswersScreen: false,
            assessmentEndScreenInfo: ''
        }, () => {
            this.getUserPracticeActivity()
        })
    }

    hideViewAnswer() {
        this.setState({
            showAssessmentViewAnswersScreen: false,
            assessmentEndScreenInfo: ''
        })
    }

    hideViewAnswersScreen() {
        this.setState({
            showAssessmentViewAnswersScreen: false,
            assessmentEndScreenInfo: ''
        }, () => {
            this.getUserPracticeActivity()
        })
    }

    showCaseStudyReport(item) {
        this.setState({ showCaseStudyReport: true, assessmentActivityId: item.assessmentActivityId })
    }

    hideChapterAssessmentReport() {
        this.setState({ showCaseStudyReport: false, assessmentActivityId: "" })
    }


    getButton(item) {
        if (item.status === 'START') {
            return (
                <div className="start-button text-center cursor-pointer" onClick={() => this.onClickCard(item)}>
                    Start
                </div>
            )
        } else if (item.status === 'IN_PROGRESS') {
            return (
                <div className="start-button text-center cursor-pointer" onClick={() => this.onClickCard(item)}>
                    Resume
                </div>
            )
        } else if (item.status === 'COMPLETED') {
            return (
                <div className="d-flex align-items-center" >
                    {/* <div className="insights-button text-center cursor-pointer" onClick={() => this.showCaseStudyReport(item)}>
                        Insights
                    </div> */}
                    <div className="learning-gap-button text-center ml-4 cursor-pointer"
                        onClick={() => this.showViewAnswerScreen({
                            meta: {
                                chapterKey: this.meta.chapterKey || this.meta.key,
                                chapterTitle: this.meta.chapterTitle || this.meta.title || 'Chapter',
                                categoryThemeId: 1,
                                assessmentActivityId: item.assessmentActivityId,
                                from: "CASE STUDY"
                            }
                        })}>
                        View Answers
                    </div>
                </div>
            )
        }
    }

    renderBreadcrumb = () => {
        const chapterTitle = this.meta.chapterTitle || this.meta.title || 'Chapter';
        return (
            <div className="breadcrumb mt-2">
                <span className="home cursor-pointer" onClick={this.goToHomeScreen}>{`Home >`}</span>
                <span className="title-1 pl-2 cursor-pointer" onClick={this.goToChapter}>{`${chapterTitle} >`}</span>
                <span className="title-1 pl-2 cursor-pointer" onClick={this.goToExamPrepKit}>{`Exam Prep Kit >`}</span>
                <span className="title-1 pl-2 cursor-pointer" onClick={this.goBackToTableOfContents}>{`Table of Contents >`}</span>
                <span className="title-1 pl-2 active">{`Prepare and Practice Case Study`}</span>
            </div>
        );
    }

    render() {
        if (this.state.loading) {
            return <Loading />;
        }

        if (this.state.showCaseStudyStartScreen) {
            return <CaseStudyStartScreen
                back={() => this.hideCaseStudyStartScreen()}
                delegate={this}
                meta={this.state.startAssessmentMetaInfo} />
        }

        if (this.state.showAssessmentEngine) {
            return (
                <AssessmentEngine meta={this.state.assessmentEngineMetaInfo} delegate={this} />
            )
        }

        if (this.state.showAssessmentEndScreen) {
            return (
                <CaseStudyEndScreen
                    metaInfo={this.state.assessmentCompletedMetaInfo}
                    delegate={this}
                    isEpkV2={true}
                    calledFrom="EXAM_PREP_KIT_V2"
                    onSelectChapter={this.props.onSelectChapter} />
            )
        }

        if (this.state.showAssessmentViewAnswersScreen) {
            return (
                <MyAssessmentResult
                    delegate={this} meta={this.state.assessmentEndScreenInfo} onSelectChapter={this.props.onSelectChapter}
                    hideViewAnswersScreen={() => this.hideViewAnswer(true)} />
            )
        }

        if (this.state.showCaseStudyReport) {
            return <ChapterAssessmentPerformanceReport delegate={this}
                assessmentActivityId={this.state.assessmentActivityId}
                questionType={'Case Study Based Questions'}
                from={'CASE_STUDY'} chapterTitle={this.meta.chapterTitle || this.meta.title || 'Chapter'} />
        }



        if (this.state.showStandardClassworkExperience) {
            return (
                <div className="standard-classwork-experience">
                    <StandardClassworkExperience
                        delegate={this}
                        params={this.state.params}
                    />
                </div>
            );
        }

        // 1. In-app PDF Viewer (renders on click Start, just like Revise TOC)
        if (this.state.showPdfViewer) {
            return (
                <PdfViewer
                    delegate={this}
                    pdfTitle={this.state.pdfTitle}
                    pdfUrl={this.state.pdfUrl}
                    chapterKey={this.meta.chapterKey || this.meta.key}
                    attemptNumber={this.state.pdfAttemptNumber}
                />
            );
        }
        // 2. Prepare and Case Study Overview Screen (shown after closing or before opening PDF)
        const chapterTitle = this.meta.chapterTitle || this.meta.title || 'Chapter';
        const isCompleted = this.state.isCompleted;

        return (
            <div className="prepare-and-case-study pl-4 pr-4 pt-2">
                {this.renderBreadcrumb()}

                <div className="header-banner">
                    <img
                        className="header-image-size"
                        src={getThemeImageSource(ImageConstants.PRACTICE_QUESTION_HEADER, this.state.categoryThemeId)}
                        alt="Header Banner"
                    />
                    <div className="title-section">
                        <div className="title">Prepare and Practice Case Study</div>
                        <div className="chapter-title">{chapterTitle}</div>
                    </div>
                </div>

                <div className="divider-line"></div>

                {/* <div className="info-banner">
                    <span className="info-icon">📖</span>
                    <span className="info-text">
                        Read through the Case Study scenario and key preparation materials to develop contextual understanding and problem-solving skills for your exams.
                    </span>
                </div> */}

                <div className="case-study-list">
                    <div className="case-study-card" onClick={this.openPdfViewer}>
                        <div className="card-left">
                            <div className="case-study-icon-wrapper">
                                <img
                                    className="case-study-icon"
                                    src={getImageSource(ImageConstants.PRACTICE_QUESTION_ICON)}
                                    alt="Case Study"
                                />
                            </div>
                            <div className="card-details">
                                <div className="card-title">{`${chapterTitle} — Case Study Material`}</div>
                                <div className="card-subtitle">Comprehensive case study document with contextual problems</div>
                            </div>
                        </div>

                        <div className="card-right">
                            {isCompleted && (
                                <span className="status-pill">✓ Completed</span>
                            )}
                            <button
                                className="start-btn cursor-pointer"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    this.openPdfViewer();
                                }}
                            >
                                {isCompleted ? 'Revise' : 'Start'}
                            </button>
                        </div>
                    </div>
                </div>

                <div className="divider-line"></div>
                {
                    this.state.showCaseStudyQuestionsList && this.state.caseStudyQuestionsList && this.state.caseStudyQuestionsList.length > 0 &&
                    <>
                        <div className="concept-title mt-2 mb-3">Practice Case Study Questions</div>
                        {this.state.caseStudyQuestionsList.map((question, index) => (
                            <>
                                <div className="elo-row row mr-0 ml-0 mb-2">
                                    <div className="col-10 row flex-row align-items-center  elo">

                                        <div className="elo-title col pl-0">{question.caseStudyTitle}</div>
                                    </div>
                                    <div className="col-2 column-width text-center status-button cursor-pointer" onClick={() => this.showStandardClassworkExperience(question, index)}>
                                        <div >
                                            <div className="custom-button cursor-pointer"><span style={{}}>{question.status === 'Start' ? 'Start' : question.status === 'Completed' ? 'Try Again' : 'Start'}</span></div>
                                        </div>

                                    </div>
                                </div>
                                <div className="divider-line"></div>
                            </>
                        ))}
                    </>

                }

                {
                    <>
                        {
                            this.state.caseStudyQuestionsList.length === 0 && this.state.userPracticeActivity && this.state.userPracticeActivity.length ?
                                <>
                                    <div className="concept-title mt-2 mb-3">Practice Case Study Questions</div>
                                    {
                                        this.state.userPracticeActivity.map((activity, index) => (
                                            <div className="question-set row mr-0 ml-0 mb-4 pb-4 align-items-center">
                                                <div className="col pl-0">
                                                    <div className="d-flex align-items-center">
                                                        {/* <span className="set-text">Case Study {index + 1}</span> */}
                                                        <div className="mb-2 case-study-title"><CwContentViewer content={activity.practiceQuestion.caseStudyTitle} /></div>
                                                        {/* <img className="clock-icon-size ml-3" src={getImageSource(ImageConstants.GRAY_QUESTION_MARK_ICON)} />
                                                                            <span className="approximate-text ml-1">{activity.approximateQuestions} Questions</span>
                                                                            <img className="clock-icon-size ml-3" src={getImageSource(ImageConstants.GRAY_CLOCK_ICON)} />
                                                                            <span className="approximate-text ml-1">Approx {activity.approximateTime} mins</span> */}
                                                    </div>
                                                </div>
                                                <div className="col-3 pr-0 d-flex justify-content-end">
                                                    {this.getButton(activity)}
                                                </div>
                                            </div>
                                        ))
                                    }
                                </>
                                :
                                this.state.caseStudyQuestionsList.length === 0 && (
                                    <div className="text-center">No Case Study Found for the Chapter : <strong>{this.meta.chapterTitle}</strong></div>
                                )
                        }
                    </>
                }
            </div>
        );
    }
}
